var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 448,
    height: 448,
    viewBox: "0 0 448 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M416,32H31.9A32.138,32.138,0,0,0,0,64.3V447.7A32.138,32.138,0,0,0,31.9,480H416a32.223,32.223,0,0,0,32-32.3V64.3A32.223,32.223,0,0,0,416,32ZM135.4,416H69V202.2h66.5V416ZM102.2,173a38.5,38.5,0,1,1,38.5-38.5A38.517,38.517,0,0,1,102.2,173ZM384.3,416H317.9V312c0-24.8-.5-56.7-34.5-56.7-34.6,0-39.9,27-39.9,54.9V416H177.1V202.2h63.7v29.2h.9c8.9-16.8,30.6-34.5,62.9-34.5,67.2,0,79.7,44.3,79.7,101.9Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f8359dca91116e71bd4af1d9e6b19f51.svg";
export { ForwardRef as ReactComponent };